import Header from './components/common/Header/Header';
import Footer from './components/common/Footer/Footer';
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import './App.css';
import { Box, Container, CssBaseline } from '@mui/material';
import WizardLaunchStepper from './components/common/WizardLaunchStepper/WizardLaunchStepper';
import ShoppingCart from './components/ShoppingCart/ShoppingCart';
import Contact from './components/Contact/Contact';
import ContactSuccess from './components/Contact/ContactSuccess';
import Checkout from './components/Checkout/CheckoutForm';
import PaymentSuccess from './components/PaymentSuccess/PaymentSuccess';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useRef } from 'react';
import CourseSelection from './components/enrolmentWizardUserJourney/CourseSelection/CourseSelection';
import StateSelection from './components/enrolmentWizardUserJourney/StateSelection/StateSelection';
import EndorsementSelection from './components/enrolmentWizardUserJourney/EndorsementSelection/EndorsementSelection';
import CDLTypeSelection from './components/enrolmentWizardUserJourney/CDLTypeSelection/CDLTypeSelection';
import VideoSelection from './components/enrolmentWizardUserJourney/VideoSelection/VideoSelection';
import CourseRecommendation from './components/enrolmentWizardUserJourney/CourseRecommendation/CourseRecommendation';
import MoreClassSelection from './components/enrolmentWizardUserJourney/MoreClassSelection/MoreClassSelection';
import DirectCourseSelection from './components/enrolmentWizardUserJourney/DirectCourseSelection/DirectCourseSelection';

// Component to handle navigation and route changes
function RouteWrapper({ Component }) {
  const location = useLocation();
  const navigate = useNavigate();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    // Check if this is a back/forward navigation
    const isBackForward =
      window.performance?.getEntriesByType('navigation')[0]?.type ===
      'back_forward';

    // If path changed and it's a back/forward navigation
    // if (prevPathRef.current !== location.pathname && isBackForward) {
    //   window.location.reload();
    // }

    prevPathRef.current = location.pathname;
  }, [location]);

  return <Component />;
}

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme='colored'
        pauseOnHover
      />
      <CssBaseline />
      <Header />
      <Box
        className='middle-content-wrap'
        style={{ background: '#FAFAFA' }}
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Container maxWidth='lg' sx={{ flex: 1, pb: 2 }}>
          <Routes>
            {/* Registration Routes */}
            <Route
              path='/'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/course-selection'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/state-selection'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/endorsement-selection'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/cdl-type'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/video-selection'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/course-recommendation'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
            <Route
              path='/more-class-selection'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />

            {/* Other Routes */}
            <Route
              path='/shoppingcart'
              element={<RouteWrapper Component={ShoppingCart} />}
            />
            <Route
              path='/paymentsuccess'
              element={<RouteWrapper Component={PaymentSuccess} />}
            />
            <Route
              path='/contact'
              element={<RouteWrapper Component={Contact} />}
            />
            <Route
              path='/contactsuccess'
              element={<RouteWrapper Component={ContactSuccess} />}
            />
            <Route
              path='/checkout'
              element={<RouteWrapper Component={Checkout} />}
            />
            <Route
              path='/direct-course-selection'
              element={<RouteWrapper Component={DirectCourseSelection} />}
            />
            <Route
              path='*'
              element={<RouteWrapper Component={WizardLaunchStepper} />}
            />
          </Routes>
        </Container>
      </Box>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
